(() => {
  if (window.ntStoryVideoReady) return;
  window.ntStoryVideoReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = [...document.querySelectorAll('.ntp-story video')];
  if (!videos.length) return;
  videos.forEach(video => video.addEventListener('play', () => {
    document.querySelectorAll('video').forEach(other => {
      if (other !== video && !other.paused) other.pause();
    });
  }));
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const video = entry.target;
    if (!entry.isIntersecting) {
      video.pause();
    } else if (!reduced.matches && video.muted && video.paused) {
      video.play().catch(() => {});
    }
  }), { threshold: 0.55 });
  videos.forEach(video => observer.observe(video));
  reduced.addEventListener('change', event => {
    if (event.matches) videos.forEach(video => video.pause());
  });
})();
